import { Component, ViewChild } from "@angular/core";
import { Router } from "@angular/router";

import { Store, select } from "@ngrx/store";
import { PlatformLocation } from "@angular/common";
import { take } from "rxjs/operators";
import { clientConfig } from "../../../shared/constant/app.constant";
import { NavButton } from "../../../shared/components/navigation/next-button.component";
import { AppFlowService } from "../../../shared/services/app-flow/app-flow.service";
import { CopyHelpers } from "../../../shared/helpers/copy.helpers";
import { ReturnItemsDetailsComponent } from "./return-order-details/return-items-details.component";
import { TenantOverrideService } from "ClientApp/src/app/shared/services/tenant-overrides/tenant-override.service";
import { Subscription } from "rxjs/internal/Subscription";
import { OverrideToggle } from "ClientApp/src/app/shared/services/tenant-overrides/tenant-override.models";

@Component({
  selector: "app-return-items",
  templateUrl: "./return-items.component.html",
  styleUrls: ["./return-items.component.scss"],
})
export class ReturnItemsComponent {
  @ViewChild(ReturnItemsDetailsComponent, { static: false }) childcomp: ReturnItemsDetailsComponent;

  ItemCardDetails: any[];
  details: any;
  selection: any;
  show: boolean;
  showdata: boolean;
  emptyBasket: boolean;
  refundTotal: any = 0;
  refundDeductionRate: any = null;
  refundDeductionTotal: any = 0;
  counter: any;
  refundedProducts: any;
  brandInfo: BrandingInfo = {
    logoSrc: clientConfig.LOGO_URL, //this.getSampleBase64Image(),
  };
  nextButton: NavButton = {
    buttonText: "Continue",
    cssClass: "next-btn",
    isDisable: true,
  };
  screenNav: NavButton = {
    buttonText: "Select return items",
    cssClass: "my-class",
    routeUrl: "/d/main",
    number: 1,
  };
  orderData: any;
  currency: any;
  showError: any = {
    show: false,
    isCustomMessage: false,
  };
  showRefund = clientConfig.SHOW_REFUND === "True";

  private readonly subscription: Subscription;
  ShowInformationCheckBox: boolean;
  InformationCheckBoxText: string;
  InformationCheckBoxAccepted: boolean = false;

  constructor(
    private router: Router,
    private appFlowService: AppFlowService,
    private store: Store<AppState>,
    private location: PlatformLocation,
    private tenantOverrideService: TenantOverrideService
  ) {
    const route = this.appFlowService.findRouteFromSequence("itemselection");
    this.appFlowService.activeStepId = this.screenNav.number;
    console.log("activate", this.appFlowService.activeStepId);
    this.nextButton.routeUrl = `/d/${route.next}`;
    this.screenNav.routeUrl = `/d/${route.back}`;
    this.store.pipe(select("orderData")).subscribe((order) => {
      this.orderData = CopyHelpers.deepCopy(order);
    });
    location.onPopState(() => {
      this.appFlowService.activeStepId = 0;
    });
    this.store.pipe(select("returnOrder")).subscribe((returnOrder) => {
      if (returnOrder.items.length) {
        //copy data from return order and
        //remaing from order data to show on UI
        //find order
        if (this.orderData.orders.length) {
          const order = this.orderData.orders.find((o) => o.orderNumber === returnOrder.orderNumber);

          if (order) {
            this.currency = order.orderLines[0].currency; //Takes the fist currency in the first orderline.
            this.refundDeductionRate = order.deductionRate;
            order.orderLines = order.orderLines.map((item) => {
              const returnItem = returnOrder.items.find((i) => i.internalIdentifier === item.internalIdentifier);
              if (returnItem) return returnItem;

              delete item.invalidProps;
              return item;
            });
          }
        }

        this.orderData = CopyHelpers.deepCopy(this.orderData);
      }
    });

    this.subscription = this.tenantOverrideService.overrideToggles.subscribe((toggles) => {
        this.ShowInformationCheckBox = toggles.includes(OverrideToggle.ShowInformationCheckBox);
        this.InformationCheckBoxText = this.tenantOverrideService.getInformationCheckBoxText();
      });
  }

  display(index) {
    this.selection = index;
    this.show = !this.show;
  }
  showDetails(index) {
    this.details = index;
    this.showdata = !this.showdata;
  }

  calculateRefund(emittedOrderData: any) {
    const order = emittedOrderData;
    this.emptyBasket = true;
    this.refundTotal = 0;

    order.orders[0].orderLines.forEach((element) => {
      if (element.returnQuantity !== null && element.returnQuantity !== undefined && element.active) {
        this.refundTotal += element.unitPrice * element.returnQuantity;
        this.emptyBasket = false;
      }
    });
    this.refundedProducts = order.orders[0].orderLines;
    if (this.refundDeductionRate !== undefined && this.refundDeductionRate !== null) {
      this.refundDeductionTotal = Math.fround(this.refundTotal * this.refundDeductionRate * 100);
      this.refundDeductionTotal = this.refundDeductionTotal / 100;
    } else {
      this.refundDeductionTotal = 0;
    }
  }

  navigate() {
    const route = this.appFlowService.findRouteFromSequence("itemselection");
    let order: any;
    this.store
      .pipe(select("returnOrder"))
      .pipe(take(1))
      .subscribe((ro) => {
        order = ro;
      });
    if (this.validate(order)) {
      this.router.navigate([`/d/${route.next}`]);
    }
  }

  validate(returnOrder) {
    let isValid = false;
    this.childcomp.status = true;
    if (returnOrder.items && returnOrder.items.length) {
      //test all the itmes from returnOrder is valid
      // if not fill error in orderData to show on UI
      if (this.orderData.orders.length) {
        const order = this.orderData.orders.find((o) => o.orderNumber === returnOrder.orderNumber);
        if (order) {
          let isAllItemsValid = true;
          order.orderLines.forEach((orderLine) => {
            let thisItemValid = true;

            const item = returnOrder.items.find((i) => i.internalIdentifier === orderLine.internalIdentifier);
            // let invalidProps = [];
            if (item) {
              if (!orderLine.reasonForReturn || orderLine.reasonForReturn === "") {
                thisItemValid = false;
                //    invalidProps.push("reasonForReturn");
              }
              if (!orderLine.returnQuantity || orderLine.returnQuantity < 1) {
                thisItemValid = false;
                //   invalidProps.push("returnQuantity");
              }
            }

            if (!thisItemValid) {
              isAllItemsValid = false;
            }
            // orderLine.invalidProps = invalidProps;
          });

          this.orderData = CopyHelpers.deepCopy(this.orderData);

          if (!isAllItemsValid) {
            this.showError = {
              show: true,
              message: "missingReturnInformation",
              isCustomMessage: false,
            };
            this.childcomp.validateReturnOrderData();
          }
          else if (this.ShowInformationCheckBox && !this.InformationCheckBoxAccepted) {
            this.showError = {
              show: true,
              message: "Please accept the information checkbox to proceed.",
              isCustomMessage: true,
            };
          }
          else {
            this.showError = {
              show: true,
              message: null,
              isCustomMessage: false,
            };
            isValid = true;
          }
        }
      }
    } else {
      this.showError = {
        show: true,
        message: "noItemSelected",
      };
      this.childcomp.validateReturnOrderData();
    }

    return isValid;
  }
}
